import { isFunction } from 'util/functions'

const startedSnackbarDefaults = {
  enabled: false,
  message: 'Action started',
  link: undefined,
  duration: 3000,
}

const successSnackbarDefaults = {
  enabled: true,
  message: 'Action completed',
  link: undefined,
  duration: 3000,
}

const failedSnackbarDefaults = {
  enabled: true,
  message: 'Action failed',
  link: undefined,
  duration: 3000,
}

const resolveSnackbar = (defaults, snackbar, payload, options) => {
  const resolvedSnackbar = isFunction(snackbar)
    ? snackbar(payload, options)
    : snackbar
  const snackbarFinal = {
    ...defaults,
    ...(resolvedSnackbar || {}),
  }

  if (isFunction(snackbarFinal.message)) {
    snackbarFinal.message = snackbarFinal.message(payload, options)
  }

  return snackbarFinal
}

export default function snackbarActionModule(phase, action, _payload, options) {
  const {
    moduleOptions: {
      snackbar: {
        enabled = false,
        started: startedSnackbar = startedSnackbarDefaults,
        success: successSnackbar = successSnackbarDefaults,
        failed: failedSnackbar = failedSnackbarDefaults,
      } = {},
    } = {},
  } =
    options || {}

  if (!enabled) return action

  if (phase === 'STARTED') {
    const startedSnackbarFinal = resolveSnackbar(
      startedSnackbarDefaults,
      startedSnackbar,
      _payload,
      options
    )
    if (startedSnackbarFinal.enabled) {
      Object.assign(action, {
        snackbar: startedSnackbarFinal,
      })
    }
  } else if (phase === 'SUCCESS') {
    const successSnackbarFinal = resolveSnackbar(
      successSnackbarDefaults,
      successSnackbar,
      _payload,
      options
    )
    if (successSnackbarFinal.enabled) {
      Object.assign(action, {
        snackbar: successSnackbarFinal,
      })
    }
  } else if (phase === 'FAILED') {
    const failedSnackbarFinal = resolveSnackbar(
      failedSnackbarDefaults,
      failedSnackbar,
      _payload,
      options
    )
    if (failedSnackbarFinal.enabled) {
      Object.assign(action, {
        snackbar: failedSnackbarFinal,
      })
    }
  }

  return action
}
